export function isWebAssemblySupported(): boolean {
  return typeof WebAssembly === "object";
}
